import { Navigate, useLocation } from "react-router-dom";
import { isMarketingDomain, isMarketingPath } from "@/lib/marketing-domain";

/**
 * Catch-all for a signed-out visitor on a path no public route claims.
 *
 * It used to be `<Navigate to="/" />`, which swallowed every app deep link
 * (`/students?tab=all`) into the marketing home and lost the destination:
 * the app routes only mount once signed in, so ProtectedRoute's
 * `/login?next=` redirect was never reached. A path that is not a marketing
 * page is therefore sent to sign-in carrying its destination; a stray
 * marketing path (`/platform/nope`) still falls back to the home page.
 *
 * On the marketing host (campushubai.com) there is no sign-in to send anyone
 * to — the app does not run there — so EVERY unknown path falls back to the
 * marketing home. The `/login?next=` hand-off is for the tenant / app hosts.
 */
export function SignedOutFallback() {
  const { pathname, search } = useLocation();
  if (isMarketingDomain() || isMarketingPath(pathname)) return <Navigate to="/" replace />;
  return <Navigate to={`/login?next=${encodeURIComponent(pathname + search)}`} replace />;
}
